import React from "react";
import { useReactFlow } from 'reactflow';
import { without } from "lodash";

import InteractiveList from './InteractiveList';
import AddOptionButton from './AddOptionButton';

import { uuid, hasChildren, getOptionCollection } from './utils';
import IconMC from '../../../presentation/components/IconMC';

const ListOptionsMenuStep = ({
  chatbotOption,
  updateInfo,
  errors
}) => {
  const { getNodes } = useReactFlow();
  const optionsList = getOptionCollection(chatbotOption, 'options_list');

  const enabledOptionsList = optionsList.filter((el) => el.option_deleted !== true && el.option_type !== "failure");
  const deletedOptionsList = optionsList.filter((el) => el.option_deleted == true);

  const handleInputOptChange = (index) => (e) => {
    e.preventDefault();

    const newArray = enabledOptionsList.map((item, _index) => {
      if (index === _index) {
        return { ...item, [e.target.name]: e.target.value };
      }

      return item;
    });

    updateInfo('options_list', newArray.concat(deletedOptionsList));
  };

  const maxTitleCharacters = () => {
    if (chatbotOption.interactive === 'text') return 400;
    if (chatbotOption.interactive === 'list') return 24;
    return 20;
  };

  const canRemoveOptionList = (opt) => {
    const nodes = getNodes();

    return !hasChildren(nodes, opt.node_id);
  };

  const removeOption = (opt) => {
    let newArray = [...optionsList];

    if (!opt.id) {
      newArray = without(optionsList, opt);
    } else {
      const optIndex = optionsList.lastIndexOf(opt);
      newArray[optIndex].option_deleted = true;
    }

    updateInfo('options_list', newArray);
  };

  const addNewOption = () => {
    const nodeId = uuid();

    const newArray = optionsList.concat({
      id: null,
      text: '',
      list_item_description: '',
      option_deleted: false,
      node_id: nodeId,
      source: chatbotOption.node_id,
      target: nodeId,
      parent_id: chatbotOption.id,
      fake_option: true
    });

    updateInfo('options_list', newArray);
  }

  return (
    <>
      {chatbotOption.interactive == 'list' && (
        <InteractiveList
          chatbotOption={chatbotOption}
          updateInfo={updateInfo}
          errors={errors}
        />
      )}

      <div className="col-md-12 mt-20">
        <label className="col-form-label fz-14 mr-10">¿Qué opciones tendrá el usuario para escoger?</label>
      </div>

      {errors.options_list_error && (
        <div className="col-md-12 mt-10">
          <span className="ml-10 error-msg fz-12">{errors.options_list_error}</span>
        </div>
      )}

      {enabledOptionsList.map((opt, index) => (
        <div className={`col-md-12 mt-20 d-flex ${canRemoveOptionList(opt) ? 'justify-content-start': 'justify-content-between'}`} key={`opt-for-list-${index}`}>
          <div className="col-md-1 d-flex align-items-center">
            <span className="font-500">{index + 1}</span>
          </div>
          <div className={`px-0 ${canRemoveOptionList(opt) ? 'col-md-10' : 'col-md-11'}`}>
            <div className="figma-field mb-0">
              <label>Opción</label>
              <span className="ml-10 error-msg fz-12">{opt.error}</span>
              <input
                value={opt.text}
                onChange={handleInputOptChange(index)}
                className="input"
                name="text"
                maxLength={maxTitleCharacters()}
              />
            </div>
            {chatbotOption.interactive === 'list' && (
              <div className="figma-field mb-0 mt-10">
                <label>Descripción (opcional)</label>
                <input
                  value={opt.list_item_description || ''}
                  onChange={handleInputOptChange(index)}
                  className="input"
                  name="list_item_description"
                  maxLength={72}
                  placeholder="Texto adicional bajo el título en WhatsApp"
                />
              </div>
            )}
          </div>
          {canRemoveOptionList(opt) && (
            <button
              type="button"
              className="tw-ml-4 tw-flex tw-cursor-pointer tw-items-center tw-border-0 tw-bg-transparent tw-p-1 tw-text-gray-600"
              onClick={() => removeOption(opt)}
              aria-label="Eliminar opción"
            >
              <IconMC name="trash-2-outline" size="base" />
            </button>
          )}
        </div>
      ))}

      <AddOptionButton
        chatbotOption={chatbotOption}
        optionsList={enabledOptionsList}
        addNewOption={addNewOption}
      />
    </>
  )
}

export default ListOptionsMenuStep;
